import axios from 'axios';
import { getLocalStorage, notification } from 'utils/CommonFunction';
import { handleToken } from 'utils/Auth';
import constants from 'constants/index';

const callApi = async (url, method, params, isShowNoti = false) => {
  const token = getLocalStorage('token_mcv');
  const refreshToken = getLocalStorage('refreshToken_mcv');

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `${token}`,
  };

  const axiosSetup = {
    url,
    method,
    headers,
    params: method === 'get' && params,
    data: method === 'post' && params,
    timeout: constants.TIMEOUT_REQUEST,
    dataType: 'json',
  };

  const newToken = token && refreshToken && await handleToken(refreshToken);
  let updatedAxios;

  if (newToken && typeof newToken === 'object') {
    updatedAxios = {
      ...axiosSetup,
      headers: {
        ...axiosSetup.headers,
        Authorization: `${newToken.token}`,
      },
    };
  }

  if (newToken !== false) {
    try {
      const result = await axios(newToken && typeof newToken === 'object' ? updatedAxios : axiosSetup);

      if (result && result.data && result.data.code !== constants.CODE_SUCCESS) {
        switch (result.data.code) {
          case constants.CODE_TOKEN_HASH_EXPIRE:
          case constants.CODE_LOGIN_FAIL:
          case constants.CODE_TOKEN_FAIL:
            localStorage.clear();
            window.sessionStorage.clear();
            window.location.href = `${process.env.DOMAIN}/#/login`;
            break;
          case constants.CODE_CHANGE_PASSWORD_FAIL:
            notification('error', 'Mật khẩu cũ không chính xác. Quý khách vui lòng kiểm tra lại!');
            break;
          case constants.CODE_UNAUTHORIZE:
            notification('error', 'Quý khách không có quyền truy cập chức năng này!');
            break;
          default:
            if (!isShowNoti) {
              notification('error', result.data.description);
            }
            break;
        }
      }

      return result.data;
    } catch (e) {
      console.log(e);
    }
  } else {
    localStorage.clear();
    window.sessionStorage.clear();
    window.location.href = `${process.env.DOMAIN}/#/login`;
  }

  return true;
};

export default callApi;
